import { useEffect, useState } from "react";

/**
 * Tracks a CSS media query so layout branches (rail vs Drawer, inline
 * panel vs Drawer) render one tree instead of both. Server-safe: returns
 * `false` until the first effect runs.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window === "undefined" ? false : window.matchMedia(query).matches,
  );

  useEffect(() => {
    const list = window.matchMedia(query);
    const update = (event: MediaQueryList | MediaQueryListEvent) => setMatches(event.matches);
    update(list);
    list.addEventListener("change", update);
    return () => list.removeEventListener("change", update);
  }, [query]);

  return matches;
}

/** True when the viewport is at least `width` CSS pixels wide. */
export function useMinWidth(width: number): boolean {
  return useMediaQuery(`(min-width: ${width}px)`);
}
